
import { IBarline } from "./barline";
import { ISignature } from "./signature";
import { IBar } from "./bar";
import { IDoPos } from "./doPos";
import { ISettings } from "./settings";
import { TClef } from "./clef";
import { ISelectedNote } from "./selectedNote";
import { Component } from "react";
import { IKeyChange } from "./keyChange";

export * from "./barline";
export * from "./signature";
export * from "./keyChange";
export * from "./bar";
export * from "./note";
export * from "./doPos";
export * from "./settings";
export * from "./barAccidental";
export * from "./steming";
export * from "./beaming";
export * from "./spaces";
export * from "./rhytNameSolution";
export * from "./clef";
export * from "./currentNote";
export * from "./selectedNote";
export * from "./scoreProps";

export interface IScore {
    barlines: IBarline[],
    signatures: ISignature[],
    keyChanges?: IKeyChange[],
    bars: (IBar | null)[],
    clef?: TClef,
    doPos: IDoPos,
    doClef?: boolean,
    settings: ISettings,
    [prop: string]: any,
    octave0?: number,
    trupletLeft?: number,
    doClefOffset?: number[],
    hideClefs?: boolean,
};

export interface IScoreState {
    score: IScore,
    activeVoice: number,
    selectedNote: ISelectedNote | null,
    restMode: boolean,
    playing: boolean,
    isChangeSignature: boolean,
    isChangeBarline: boolean,
    changingBarline: number | null,
    changingSignature: number | null,
    fullBar: boolean,
    inputByPiano: boolean,
    asideModal: boolean,
    isChangingGhostBarline: boolean,
    isMelodyTable: boolean,
    hasSolfaPanel: boolean,
    playingNote?: number,
    isChangeKey: boolean,
    changingKeyBar: number | null,
}
export interface IScoreEditorThis {
    state: IScoreState,
    props: {
        taskType: string,
    }
    setState: Component<unknown, IScoreState>["setState"],
    distribution: number[][],
    scoreRef: HTMLDivElement,
    deselectNote: () => void,
    hasClickEventListener: boolean,
};
